var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 11",
    style: {
      enableBackground: "new 0 0 24 11"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.2H3.3V8H1.7V.1h3.4c.8 0 1.4.2 1.9.6s.7 1 .7 1.9c0 .9-.2 1.6-.7 2s-1.1.6-2 .6zm.8-1.7c.2-.2.3-.5.3-.9s-.1-.7-.3-.9c-.2-.2-.5-.2-.9-.2H3.3v2.3h1.5c.5 0 .8-.1 1-.3zM12.6 8H9.2V.1h3.4c.5 0 .9.1 1.2.2.6.2 1 .5 1.3 1 .3.4.5.8.6 1.3.1.5.2.9.2 1.3 0 1.1-.2 1.9-.6 2.7-.6.9-1.5 1.4-2.7 1.4zm1.2-5.9c-.3-.4-.8-.6-1.5-.6h-1.5v5.2h1.5c.8 0 1.3-.4 1.6-1.2.2-.5.3-1 .3-1.5 0-.8-.1-1.5-.4-1.9zM22.9 1.5h-4v1.8h3.5v1.4h-3.5V8h-1.6V.1h5.6v1.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.83196f93109fc675fe5c817061516a4d.svg";
export { ForwardRef as ReactComponent };